











import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({})
export default class Toggle extends Vue {
    @Prop() private checked!: boolean;

    get checkModel() {
        return this.checked || false;
    }

    private onClick() {
        this.$emit("change", !this.checked)
    }
}

